function ProductSections() {
    this.init();
}

ProductSections.prototype.init = function () {
    this.productHandle = this.getProductHandle();
    this.selectors = ["product-information"];
    this.syncWithMainProductForm();
    this.currentVariant = this.getVariantFromUrl();
    // console.info('[ProductSections] Product Handle:', this.productHandle);
    // console.info('[ProductSections] Selectors:', this.selectors);
    // console.info('[ProductSections] Current Variant:', this.currentVariant);
};

ProductSections.prototype.syncWithMainProductForm = function () {
    var self = this;

    // Listen for the theme's variant:change event via eventBus
    if (window.eventBus) {
        // console.info('[ProductSections] Syncing with main product form via eventBus');
        window.eventBus.on('variant:change', function (eventData) {
            // console.info('[ProductSections] Variant changed via eventBus:', eventData);
            var newVariant = eventData.variant ? eventData.variant.id.toString() : null;
            if (newVariant && newVariant !== self.currentVariant) {
                // console.info('[ProductSections] Variant changed via eventBus:', newVariant);
                self.currentVariant = newVariant;
                self.fetchVariantPage(self.productHandle, self.currentVariant);
            }
        });
    } else {
        console.warn('[ProductSections] eventBus not available, falling back to URL monitoring');
    }
};

ProductSections.prototype.getVariantFromUrl = function () {
    var urlParams = new URLSearchParams(window.location.search);
    var variant = urlParams.get('variant');
    // console.info('[ProductSections] Variant from URL:', variant);
    return variant;
};

ProductSections.prototype.getProductHandle = function () {
    var pathParts = window.location.pathname.split('/');
    var productsIndex = pathParts.indexOf('products');
    var productHandle = pathParts[productsIndex + 1];
    // console.info('[ProductSections] Product Handle:', productHandle);
    if (productsIndex !== -1 && productHandle) {
        return productHandle;
    }
    return null;
};

ProductSections.prototype.fetchVariantPage = function (productHandle, variantId) {
    var self = this;
    // Use AJAX to fetch the content related to the selected variant and update the collapsible section
    fetch(`/products/${productHandle}?variant=${variantId}`)
        .then(response => response.text())
        .then(html => {
            // Parse the new variant details from the returned HTML
            const parser = new DOMParser();
            self.doc = parser.parseFromString(html, 'text/html');
            // console.info('[ProductSections] Variant Page:', self.doc);
            self.updateSections()
        })
        .catch(error => {
            console.error('Error fetching variant content:', error);
        });
}

ProductSections.prototype.updateSections = function () {
    var self = this;

    // console.info('[ProductSections] Updating sections:', this.selectors);

    this.selectors.map(selector => {
        var section = document.querySelector(selector);
        if (section) {
            var newSection = self.doc.querySelector(selector);
            if (newSection) {
                // console.info('[ProductSections] Old Section:', section);
                // console.info('[ProductSections] New Section:', newSection);
                section.innerHTML = newSection.innerHTML
            }
        }
    });
}


new ProductSections();

